import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Footer } from "./components/Footer";
import NavigationBar from "./components/NavigationBar/NavigationBar";
import Feedbackform from "./components/PeerChat/feedbackform/feedbackform";
import IntakeForm1 from "./components/PeerChat/intakeform1/intakeform1";
import IntakeForm3 from "./components/PeerChat/intakeform3/intakeform3";
import EmotionalIntelligenceQuiz from "./components/SelfTest/EmotionalIntelligence/EmotionalIntelligence";
import EmotionalIntelligenceIntro from "./components/SelfTest/EmotionalIntelligence/Intro";
import PersonalityAsessmentIntro from "./components/SelfTest/PersonalityAsessment/Intro";
import PersonalityAsessmentQuiz from "./components/SelfTest/PersonalityAsessment/PersonalityAssessment";
import SelfEsteemIntro from "./components/SelfTest/SelfEsteem/Intro";
import SelfEsteemQuiz from "./components/SelfTest/SelfEsteem/SelfEsteem";
import StressScaleIntro from "./components/SelfTest/StudentStressScale/Intro";
import StressScaleInstructions from "./components/SelfTest/StudentStressScale/Instructions";
import StressScaleQuiz from "./components/SelfTest/StudentStressScale/StudentStressScale";
import GeneralHealthIntro from "./components/SelfTest/GeneralHealth/Intro";
import GeneralHealthQuiz from "./components/SelfTest/GeneralHealth/GeneralHealth";
import { About } from "./Pages/About";
import SignIn from "./Pages/auth/SignIn";
import SignUp from "./Pages/auth/SignUp";
import { Home } from "./Pages/Home/Home";
import Profile from './Pages/Profile/profile'
import { NoMatch } from "./Pages/NoMatch";
import PeerChat from "./Pages/PeerChat/Peerchat";
import { SelfTest } from "./Pages/Self-Test/SelfTest";
import Contact from "./Pages/ContactUs/contact";
import  Blogs from "./components/Blogs/Blogs";
import ReadMore from "./components/Blogs/ReadMore";
import WritepostBtn from "./components/Blogs/writepostBtn";
class App extends React.Component {
  showToast = (type, message) => {
    // 0 = warning, 1 = success
    switch (type) {
      case 0:
        toast.warning(message);
        break;
      case 1:
        toast.success(message);
        break;
      default:
        break;
    }
  };
  render() {
    return (
      <React.Fragment>
        <Router>
          <ToastContainer
            autoClose={2000}
            hideProgressBar={true}
            position={toast.POSITION.BOTTOM_RIGHT}
          />
          <NavigationBar />

          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
            <Route path="/signin" component={SignIn} />
            <Route path="/signup" component={SignUp} />
            <Route exact path="/profile" component={Profile} />
            <Route path="/Blogs" component={Blogs} />
            <Route exact path="/Readmore/:id"  component={ReadMore} />
          <Route exact path="/writepostBtn"  render={props => <WritepostBtn showToast={this.showToast} {...props}/>}/>
            <Route exact path="/selfevaluation" component={SelfTest} />
            <Route
              exact
              path="/selfevaluation/personality-assessment"
              component={PersonalityAsessmentIntro}
            />
            <Route
              path="/selfevaluation/personality-assessment/quiz"
              component={PersonalityAsessmentQuiz}
            />
            <Route
              exact
              path="/selfevaluation/emotional-intelligence"
              component={EmotionalIntelligenceIntro}
            />
            <Route
              path="/selfevaluation/emotional-intelligence/quiz"
              component={EmotionalIntelligenceQuiz}
            />
            <Route
              exact
              path="/selfevaluation/self-esteem"
              component={SelfEsteemIntro}
            />
            <Route
              path="/selfevaluation/self-esteem/quiz"
              component={SelfEsteemQuiz}
            />
            <Route
              exact
              path="/selfevaluation/stress-scale"
              component={StressScaleIntro}
            />
            <Route
              path="/selfevaluation/stress-scale/instructions"
              component={StressScaleInstructions}
            />
            <Route
              path="/selfevaluation/stress-scale/quiz"
              component={StressScaleQuiz}
            />
            <Route
              exact
              path="/selfevaluation/general-health"
              component={GeneralHealthIntro}
            />
            <Route
              path="/selfevaluation/general-health/quiz"
              component={GeneralHealthQuiz}
            />

            <Route
              path="/peerchat"
              render={(props) => (
                <PeerChat showToast={this.showToast} {...props} />
              )}
            />
            <Route
              path="/intakeform1"
              render={(props) => (
                <IntakeForm1 showToast={this.showToast} {...props} />
              )}
            />
            <Route
              path="/feedbackform"
              render={(props) => (
                <Feedbackform showToast={this.showToast} {...props} />
              )}
            />
            <Route
              path="/intakeform3"
              render={(props) => (
                <IntakeForm3 showToast={this.showToast} {...props} />
              )}
            />
            <Route exact path="/contact-us" component={Contact} />
            <Route component={NoMatch} />
          </Switch>

          <Footer />
        </Router>
      </React.Fragment>
    );
  }
}

export default App;